<p class="copyrighttext">
  Copyright © 2023 Dr. sid. All rights reserved.
</p>
